import { render } from "./editDistribution.vue?vue&type=template&id=77d2786c&scoped=true"
import script from "./editDistribution.vue?vue&type=script&lang=js"
export * from "./editDistribution.vue?vue&type=script&lang=js"

import "./editDistribution.vue?vue&type=style&index=0&id=77d2786c&scoped=true&lang=css"
import "./editDistribution.vue?vue&type=style&index=1&id=77d2786c&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d2786c"]])

export default __exports__